import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AddPriorityWorkDayConfig, AddPriorityWorkDayConfigs, AddScheduleData, AddWorkDayConfigData, AddWorkWeekConfigData, AdministrationResultStatus, PaginationArgs, PriorityWorkDayConfigData, ScheduleData, ServiceData, ShiftTemplateData, UserProfileData } from 'src/app/clients/system-api/SystemApiClient';
import { EmployeeService } from 'src/app/services/employee.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import { ServiceService } from 'src/app/services/service.service';
import { ShiftTemplateService } from 'src/app/services/shift-template.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { CalendarRefreshService } from 'src/app/services/calendar.service';
import { PriorityWorkDayConfigService } from 'src/app/services/priority-work-day-config.service';

@Component({
  selector: 'app-shift-add-popup',
  templateUrl: './shift-add-popup.component.html',
  styleUrls: ['./shift-add-popup.component.scss']
})
export class ShiftAddPopupComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();

  serviceData: ServiceData[] | undefined = [];
  employeeData: UserProfileData[] | undefined = [];
  scheduleData: AddScheduleData[] = []
  shiftTemplateData: ShiftTemplateData[] | undefined = [];
  addPriorityWorkDayConfigs = new AddPriorityWorkDayConfigs();
  fromTime: string | undefined = "00:00";
  toTime: string | undefined = "00:00";
  yesterday = new Date();
  startingFrom: Date = new Date()
  endOn: Date = new Date()
  shiftForOneDay: boolean = false;

  addShiftModelData: AddShiftModel[] = []

  constructor(private serviceService: ServiceService,
    private employeeService: EmployeeService,
    private shiftTemplateService: ShiftTemplateService,
    private scheduleService: ScheduleService,
    private _snackBarService: SnackBarService,
    private calendarRefreshService: CalendarRefreshService,
    private priorityWorkDayConfigService: PriorityWorkDayConfigService,
    private router: Router,) {
    this.yesterday.setDate(this.yesterday.getDate() - 0)
  }

  ngOnInit(): void {
    var paginationArgs = new PaginationArgs();
    paginationArgs.skipCount = 0;
    paginationArgs.maxResultCount = 9999;
    paginationArgs.sorting = 'Id ASC';

    this.serviceService.retrieveAllServices(paginationArgs).subscribe((data) => {
      this.serviceData = data.content?.items;
    });

    this.shiftTemplateService.retrieveAllShiftTemplates().subscribe(next => {
      this.shiftTemplateData = next.content;
    });

  }

  ngAfterViewInit(): void {
    this.employeeService.retrieveAllUsers(3).subscribe((data) => {
      this.employeeData = data.content?.items;
      this.addShiftModelData = new Array<AddShiftModel>();

      for (var i = 0; i < this.employeeData!.length; i++) {

        var addShiftModel = new AddShiftModel();
        addShiftModel.employeeProfileId = this.employeeData![i].profileId;
        addShiftModel.name = this.employeeData![i].name;
        addShiftModel.surname = this.employeeData![i].surname;

        this.addShiftModelData.push(addShiftModel)
      }

    });
  }


  createScheduleWithShift() {

    if (this.shiftForOneDay == true) {

      this.addPriorityWorkDayConfigs.priorityWorkDayConfigList = new Array<AddPriorityWorkDayConfig>()

      var addPriorityWorkDayConfig = new AddPriorityWorkDayConfig()

      addPriorityWorkDayConfig.forDate = new Date(this.startingFrom)
      addPriorityWorkDayConfig.forDate.setUTCHours(addPriorityWorkDayConfig.forDate.getUTCHours() + 1)

      addPriorityWorkDayConfig.fromTime = new Date()
      addPriorityWorkDayConfig.fromTime.setUTCHours(parseInt(this.fromTime!.split(":")[0]))
      addPriorityWorkDayConfig.fromTime.setUTCMinutes(parseInt(this.fromTime!.split(":")[1]))
      addPriorityWorkDayConfig.fromTime.setMilliseconds(0)

      addPriorityWorkDayConfig.toTime = new Date()
      addPriorityWorkDayConfig.toTime.setUTCHours(parseInt(this.toTime!.split(":")[0]))
      addPriorityWorkDayConfig.toTime.setUTCMinutes(parseInt(this.toTime!.split(":")[1]))
      addPriorityWorkDayConfig.toTime.setMilliseconds(0)

      this.addPriorityWorkDayConfigs.priorityWorkDayConfigList.push(addPriorityWorkDayConfig)

      this.priorityWorkDayConfigService.addPriorityWorkDayConfigs(false, this.addPriorityWorkDayConfigs).subscribe((data) => {
        this._snackBarService.callSnackBar(data, "Successfully entered");
        if (data == AdministrationResultStatus.Success) {
          this.calendarRefreshService.triggerRefresh();
          this.closePopup();
        }
      }, error => {
        this._snackBarService.callSnackBar(error);
      });
    }

    else {

      this.scheduleData = new Array<AddScheduleData>()

      for (var i = 0; i < this.addShiftModelData.length; i++) {
        var addShiftModel = this.addShiftModelData[i]

        if (addShiftModel.shiftTemplateId != null && addShiftModel.shiftTemplateId != undefined) {

          var schedule = new AddScheduleData()
          schedule.startingFrom = this.startingFrom
          schedule.endOn = this.endOn
          schedule.employeeProfileId = addShiftModel.employeeProfileId!
          schedule.workWeekList = new Array<AddWorkWeekConfigData>()

          var shiftTemplateData = (this.shiftTemplateData?.filter(x => x.id == addShiftModel.shiftTemplateId))![0]

          for (var j = 0; j < shiftTemplateData.workWeekList!.length; j++) {

            var addWorkWeekConfigData = new AddWorkWeekConfigData()
            addWorkWeekConfigData.workDaysConfig = new Array<AddWorkDayConfigData>()

            for (var dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
              var dayOfWeekString = this.getDayOfWeekString(dayOfWeek)

              for (var z = 0; z < shiftTemplateData.workWeekList![j].workDaysConfig![dayOfWeekString].length; z++) {
                if(shiftTemplateData.workWeekList![j].workDaysConfig![dayOfWeekString][z].working !== false) {
                  var addWorkDayConfigData = new AddWorkDayConfigData()
                  addWorkDayConfigData!.dayOfWeek = shiftTemplateData.workWeekList![j].workDaysConfig![dayOfWeekString][z].dayOfWeek
  
                  addWorkDayConfigData!.fromTime = new Date(shiftTemplateData.workWeekList![j].workDaysConfig![dayOfWeekString][z].fromTime!)
                  addWorkDayConfigData!.fromTime?.setUTCHours(shiftTemplateData.workWeekList![j].workDaysConfig![dayOfWeekString][z].fromTime!.getHours())
  
                  addWorkDayConfigData!.toTime = new Date(shiftTemplateData.workWeekList![j].workDaysConfig![dayOfWeekString][z].toTime!)
                  addWorkDayConfigData!.toTime?.setUTCHours(shiftTemplateData.workWeekList![j].workDaysConfig![dayOfWeekString][z].toTime!.getHours())
  
                  addWorkWeekConfigData.workDaysConfig.push(addWorkDayConfigData!);
                }
              }
            }

            schedule.workWeekList?.push(addWorkWeekConfigData);
          }

          schedule.startingFrom.setHours(2)
          schedule.startingFrom.setMinutes(0)
          schedule.startingFrom.setMilliseconds(0)
          schedule.endOn.setHours(2)
          schedule.endOn.setMinutes(0)
          schedule.endOn.setMilliseconds(0)

          this.scheduleData.push(schedule)
        }
      }

      this.scheduleService.addSchedule(this.scheduleData).subscribe((data) => {
        this._snackBarService.callSnackBar(data, "Successfully entered");
        if (data == AdministrationResultStatus.Success) {
          this.calendarRefreshService.triggerRefresh();
          this.closePopup();
        }
      }, error => {
        this._snackBarService.callSnackBar(error);
      });
    }
  }

  closePopup() {
    this.close.emit();
  }

  getDayOfWeekString(dayOfWeek: number) {
    var dayOfWeekString = ""
    if (dayOfWeek == 0) {
      dayOfWeekString = "Sunday"
    }
    else if (dayOfWeek == 1) {
      dayOfWeekString = "Monday"
    }
    else if (dayOfWeek == 2) {
      dayOfWeekString = "Tuesday"
    }
    else if (dayOfWeek == 3) {
      dayOfWeekString = "Wednesday"
    }
    else if (dayOfWeek == 4) {
      dayOfWeekString = "Thursday"
    }
    else if (dayOfWeek == 5) {
      dayOfWeekString = "Friday"
    }
    else if (dayOfWeek == 6) {
      dayOfWeekString = "Saturday"
    }
    return dayOfWeekString;
  }

}

export class AddShiftModel {
  employeeProfileId: number | undefined | null;
  shiftTemplateId: number | undefined | null;
  name: string | undefined | null;
  surname: string | undefined | null;
}